export class InputDialogOptions {
    dialogId: string;
    inputId: string;
    hideCancelButton = false;
    titleText: string;
    contentText: string;
    cancelText = 'Cancel';
    confirmText = 'OK';
    cancelAnalyticsTag: string;
    confirmAnalyticsTag: string;
    cancelAriaLabel: string;
    confirmAriaLabel: string;
    errorMessage: string;

    constructor(options: Partial<InputDialogOptions> = {}) {
        this.dialogId = options.dialogId || '';
        this.inputId = options.inputId || '';
        this.hideCancelButton = options.hideCancelButton || false;
        this.titleText = options.titleText || '';
        this.contentText = options.contentText || '';
        this.cancelText =
            options.cancelText !== undefined
                ? options.cancelText
                : $localize`Cancel`;
        this.confirmText =
            options.confirmText !== undefined
                ? options.confirmText
                : $localize`OK`;
        this.cancelAnalyticsTag = options.cancelAnalyticsTag || '';
        this.confirmAnalyticsTag = options.confirmAnalyticsTag || '';
        this.cancelAriaLabel = options.cancelAriaLabel || this.cancelText;
        this.confirmAriaLabel = options.confirmAriaLabel || this.confirmText;
        this.errorMessage = options.errorMessage || '';
    }
}
